import type { MessengerSettings, MessengerViewName } from '@widgets/messenger/types'
import { defineStore } from '@/composition/defineStore'
import { computed, ref, type Ref } from '@/composition/vue/compositionApi'

type InitParams = {
  widgetSettings: MessengerSettings
  uniqueCode: string
  domain: string
  parentUrl: string
}

export const widgetStoreSymbol = Symbol('widgetStore')

export const useWidgetStore = defineStore(widgetStoreSymbol, () => {
  const widgetSettings = ref<MessengerSettings>() as Ref<MessengerSettings>
  const uniqueCode = ref('')
  const domain = ref('')
  const parentUrl = ref('')
  const viewNameBeforeMinimize = ref<MessengerViewName>()
  const currentViewName = ref<MessengerViewName>('idle')
  const isActiveTab = ref(true) // Browser tab is currently active
  const isLastActiveTab = ref(true) // Browser tab was last active

  const isWidgetExpanded = computed(() => {
    return currentViewName.value !== 'minimized' && currentViewName.value !== 'idle'
  })

  const init = (params: InitParams) => {
    widgetSettings.value = params.widgetSettings
    uniqueCode.value = params.uniqueCode
    domain.value = params.domain
    parentUrl.value = params.parentUrl
  }

  const setViewNameBeforeMinimize = (viewName: MessengerViewName | undefined) => {
    viewNameBeforeMinimize.value = viewName
  }

  const setCurrentViewName = (viewName: MessengerViewName) => {
    currentViewName.value = viewName
  }

  const setIsActiveTab = (isActive: boolean) => {
    isActiveTab.value = isActive
  }

  const setIsLastActiveTab = (isActive: boolean) => {
    isLastActiveTab.value = isActive
  }

  return {
    widgetSettings,
    uniqueCode,
    domain,
    parentUrl,
    viewNameBeforeMinimize,
    currentViewName,
    isActiveTab,
    isLastActiveTab,
    isWidgetExpanded,
    init,
    setViewNameBeforeMinimize,
    setCurrentViewName,
    setIsActiveTab,
    setIsLastActiveTab,
  }
})
